export const GET_HOME_DATA_TABLE_START = "GET_HOME_DATA_TABLE_START";
export const GET_HOME_DATA_TABLE_SUCCESS = "GET_HOME_DATA_TABLE_SUCCESS";
export const GET_HOME_DATA_TABLE_FAIL = "GET_HOME_DATA_TABLE_FAIL";

export const GET_VEHICLE_FILTERS_START = "GET_VEHICLE_FILTERS_START";
export const GET_VEHICLE_FILTERS_DATA = "GET_VEHICLE_FILTERS_DATA";
export const GET_VEHICLE_FILTERS_FAIL = "GET_VEHICLE_FILTERS_FAIL";

export const SET_URL = "SET_URL";

export const SET_QR_CODE = "SET_QR_CODE";

export const SET_FILTERS = "SET_FILTERS";

export const SET_SEARCH = "SET_SEARCH";

export const SET_ACTIVE = "SET_ACTIVE";

export const SET_SORT_ORDER = "SET_SORT_ORDER";

export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
